import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tabla-errores',
  templateUrl: './tabla-errores.component.html',
  styleUrls: ['./tabla-errores.component.css']
})
export class TablaErroresComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
